module.exports = __webpack_public_path__ + "fonts/AudiType-BoldItalic_4.03.eccaf867.woff2";